<template>
  <div style="padding: 0pt">
    <section class="hero is-primary is-medium gradient">
      <div class="hero-body">
        <div class="container padded">
          <h1 class="title">Welkom bij</h1>
          <img src="../assets/recht.svg" />
        </div>
      </div>
    </section>
    <section class="container" style="padding: 20pt ">
      <div class="columns features">
        <div class="column is-4">
          <div class="card is-shady" style="height:100%">
            <div class="card-image has-text-centered">
              <img src="../assets/smart.png" />
            </div>
            <div class="card-content">
              <div class="content">
                <h4>Slimme brandveiligheid</h4>
                <p>
                  Ons systeem is meer dan een digitale versie van een logboek. Doorvoeren, regelgeving en testrapporten
                  komen samen en zorgen ervoor dat de gekozen oplossing een correcte oplossing is.
                </p>
                <!-- <p>
                  <a href="#">Learn more</a>
                </p> -->
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="card is-shady" style="height:100%">
            <div class="card-image has-text-centered">
              <img src="../assets/insight.png" />
            </div>
            <div class="card-content">
              <div class="content">
                <h4>Meer inzicht</h4>
                <p>
                  Als gebouweigenaar heeft u meer inzicht in de brandveiligheid van uw gebouw. Met slimme weergaven kunt
                  u eenvoudig de status van uw brandwerende afdichtingen zien.
                </p>
                <!-- <p>
                  <a href="#">Learn more</a>
                </p> -->
              </div>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="card is-shady" style="height:100%">
            <div class="card-image has-text-centered">
              <img src="../assets/speed.png" />
            </div>
            <div class="card-content">
              <div class="content">
                <h4>Snelle en eenvoudige invoer</h4>
                <p>
                  Onze intelligente app maakt het invoeren en muteren van brandwerende afdichtingen sneller en handiger.
                  Daarnaast kunt u volledig online of offline werken.
                </p>
                <!-- <p>
                  <a href="#">Learn more</a>
                </p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Breadcrumbs from './General/Breadcrumbs'
export default {
  components: {
    Breadcrumbs
  },

  methods: {
    myCallback() {
      alert('callback from landingpage')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../sass/main.scss';
.hero.is-primary.gradient {
  $gradient-top-left: red;
  background-image: linear-gradient(141deg, $gradient-top-left, $primary 85%) !important;
}

@media (min-width: 200px) and (max-width: 1400px) {
  .padded {
    padding: 0% 12%;
  }
}
@media (min-width: 1401px) {
  .padded {
    padding: 0% 200px;
  }
}

.card-image.has-text-centered img {
  height: 120px;
  margin-top: 30px;
  opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/components/LandingPage.vue